import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { catchError, map, throwError } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class DirectiiService {
  private token!: string;
  private httpOptions: any;

  private basePath = environment.interop.basePath;
  private getDirectiiActiveUrl =
    this.basePath +
    environment.interop.urbanism.nomenclatoare.directie.getDirectiiActive;

  constructor(private http: HttpClient) {}

  getDirectii() {
    return this.http
      .get<{ errors: boolean; data: any[]; status_code: number }>(
        this.getDirectiiActiveUrl
      )
      .pipe(
        map((response) =>
          response.data.map((item) => ({
            id: item.id_directie,
            name: item.name,
          }))
        ),
        catchError((error) => {
          console.error('Error in get directii active:', error);
          return throwError(error);
        })
      );
  }

  setToken(token: string) {
    this.token = token;
    this.httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
        Authorization: `Bearer ${this.token}`,
      }),
    };
  }
}
